<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/cmdsbomatch")
          i.fa.fa-futbol
          span.ml-1 {{ $t("ui.cmd_sbo_switching") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="matchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.id") }}
                    b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                    b-form-radio(value="home_team") {{ $t("ui.home") }}
                    b-form-radio(value="away_team") {{ $t("ui.away") }}
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getMatchList(true)"
                    variant="success"
                    size="sm"
                    )
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-exchange"
                    :text="$t('ui.sbo_to_cmd')"
                    type="button"
                    @click="switchProvider('sbo','cmd')"
                    variant="secondary"
                    size="sm"
                    )
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-exchange"
                    :text="$t('ui.cmd_to_sbo')"
                    type="button"
                    @click="switchProvider('cmd','sbo')"
                    variant="secondary"
                    size="sm"
                    )
        div.card-body
          div
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="totalRow" readonly)
            div.row.clusterize
              div.col-md-12.clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position.text-center(colspan=6 width="45%")
                        span {{ $t('ui.sbo') }}
                      th.sticky-position.text-center(colspan=6 width="45%")
                        span {{ $t('ui.cmd') }}
                      th.sticky-position.text-center(rowspan=2 width="6%")
                        span {{ $t('ui.current') }}
                      th.text-center.sticky-position(rowspan=2 width="4%")
                        span {{ $t("ui.action") }}
                    tr
                      th.sticky-position(width="10%" @click="sortOrder('sbo_match_id')")
                        span {{ $t('ui.id') }}
                        i(:class="changeSortKey('sbo_match_id')")
                      th.sticky-position(width="40%" @click="sortOrder('sbo_league_name')")
                        span {{ $tc("ui.leagues", 1) }}
                        i(:class="changeSortKey('sbo_league_name')")
                      th.sticky-position(width="15%" @click="sortOrder('sbo_home_team')")
                        span {{ $t("ui.home") }}
                        i(:class="changeSortKey('sbo_home_team')")
                      th.sticky-position(width="15%" @click="sortOrder('sbo_away_team')")
                        span {{ $t("ui.away") }}
                        i(:class="changeSortKey('sbo_away_team')")
                      th.sticky-position(width="10%" @click="sortOrder('sbo_match_date_time')")
                        span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                        i(:class="changeSortKey('sbo_match_date_time')")
                      th.sticky-position(width="10%")
                        span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                      th.sticky-position(width="10%" @click="sortOrder('cmd_match_id')")
                        span {{ $t('ui.id') }}
                        i(:class="changeSortKey('cmd_match_id')")
                      th.sticky-position(width="40%" @click="sortOrder('cmd_league_name')")
                        span {{ $tc("ui.leagues", 1) }}
                        i(:class="changeSortKey('cmd_league_name')")
                      th.sticky-position(width="15%" @click="sortOrder('cmd_home_team')")
                        span {{ $t("ui.home") }}
                        i(:class="changeSortKey('cmd_home_team')")
                      th.sticky-position(width="15%" @click="sortOrder('cmd_away_team')")
                        span {{ $t("ui.away") }}
                        i(:class="changeSortKey('cmd_away_team')")
                      th.sticky-position(width="10%" @click="sortOrder('cmd_match_date_time')")
                        span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                        i(:class="changeSortKey('cmd_match_date_time')")
                      th.sticky-position(width="10%")
                        span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                  tbody.clusterize-content
                    tr(v-if="matchList.length == 0")
                      td(colspan="14").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in matchList")
                      td
                        span(:title="item.sbo_match_id") {{ item.sbo_match_id }}
                      td
                        span(:title="item.sbo_league_name") {{ item.sbo_league_name }}
                      td
                        span(:title="item.sbo_home_team") {{ item.sbo_home_team }}
                      td
                        span(:title="item.sbo_away_team") {{ item.sbo_away_team }}
                      td
                        span(:title="getDate(item.sbo_match_date)") {{ getDate(item.sbo_match_date) }}
                      td
                        span(:title="item.sbo_match_time") {{ item.sbo_match_time }}
                      td
                        span(:title="item.cmd_match_id") {{ item.cmd_match_id }}
                      td
                        span(:title="item.cmd_league_name") {{ item.cmd_league_name }}
                      td
                        span(:title="item.cmd_home_team") {{ item.cmd_home_team }}
                      td
                        span(:title="item.cmd_away_team") {{ item.cmd_away_team }}
                      td
                        span(:title="getDate(item.cmd_match_date)") {{ getDate(item.cmd_match_date) }}
                      td
                        span(:title="item.cmd_match_time") {{ item.cmd_match_time }}
                      td.text-center
                        span(:title="item.current_provider") {{ item.current_provider }}
                      td.actions
                        span
                          a.fa.fa-trash.text-primary(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    matchInfo: null,
    sportType: 1,
    sportList: [],
    matchList: [],
    currentPage: 1,
    totalRow: 0,
    matchSearch: "",
    marketType: "",
    sortKey: "sbo_league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    filterBy: "league_name",
    startDate: null,
    endDate: null,
    dStartDate: null,
    dEndDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    localeWithTime: {
      format: 'YYYY-MM-DD hh:mm A',
      useCurrent: false,
      showClear: true,
      showClose: true,
    },
  }),
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    todayWithTime() {
      let time = '23:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterday;
    this.endDate = this.today;
    this.dStartDate = this.yesterdayWithTime;
    this.dEndDate = this.todayWithTime;
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getMatchList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id != 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMatchList: function(isSearch) {
      let url = config.cmdSBOMatchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.filterBy == "id") {
        json.match_id = this.matchSearch;
      } else if (this.filterBy == "league_name") {
        json.league_name = this.matchSearch;
      } else if (this.filterBy == "home_team") {
        json.home_team = this.matchSearch;
      } else if (this.filterBy == "away_team") {
        json.away_team = this.matchSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.matchList = response.data.tbl_cmd_sbo_match_list;
                this.totalRow = this.matchList.length > 0 ? this.matchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    switchProvider: function(from, to) {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.switch_provider"),
          text: this.$t("message.switch_provider_confirm", { from: from, to: to }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSwitchProvider(from, to);
          }
        });
    },
    confirmSwitchProvider: function(from, to) {
      let url = config.switchCMDSBOUrl();;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomatch,
        from: from,
        to: to
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMatchList(true);
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete(item) {
      this.purgeMap(item);
    },
    purgeMap: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.purge_mapping"),
          text: this.$t("message.purge_cmd_sbo_mapping_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurgeMap(item);
          }
        });
    },
    confirmPurgeMap(item) {
      let url = config.purgeCMDSBOMapUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomatch,
        cmd_match_id: item.cmd_match_id,
        sbo_match_id: item.sbo_match_id,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMatchList(true);
                this.$snotify.success(this.$t("message.success"));
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getMatchList();
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getMatchList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>